import { relativeToAbsoluteURL } from '../links';

/**
 * Query params that change the content of a page, and so belong to its canonical URL.
 * Any other param (utm_*, fbclid, gclid, trk, ref, ...) is left out.
 */
export const CANONICAL_QUERY_PARAMS = ['p'];

function canonicalValue(key: string, value: string | null): string | undefined {
  if (key === 'p') {
    const page = Number(value);

    // the first page is the URL without the param
    return Number.isInteger(page) && page > 1 ? `${page}` : undefined;
  }

  return value || undefined;
}

/**
 * Builds the absolute canonical URL of the given relative path (e.g. Next.js router asPath): no fragment,
 * no trailing slash and only the query params listed in CANONICAL_QUERY_PARAMS.
 */
export function buildCanonicalURL(path: string): string {
  const [pathname, search = ''] = path.split('#')[0].split('?');
  const params = new URLSearchParams(search);

  const query = CANONICAL_QUERY_PARAMS.reduce((acc, key) => {
    const value = canonicalValue(key, params.get(key));

    return value ? { ...acc, [key]: value } : acc;
  }, {});

  const normalizedPathname = `/${pathname.replace(/^\/+|\/+$/g, '')}`;

  return relativeToAbsoluteURL(normalizedPathname, Object.keys(query).length ? query : undefined);
}
